export default {

    availableStartDateResponses: {},
    availableEndDateResponses: {},

    currentMonth: null,

    datepickerStartDate: null,
    datepickerEndDate: null,

    currentFocusedDate: null,
    
    datepickerLoading: false,
}